var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout"},[_c('div',{staticClass:"logout-container"},[_c('h3',[_vm._v(_vm._s(_vm.$t('LOGOUT_SUCCESSFULL')))]),_c('p',[_c('router-link',{staticClass:"el-button el-button--primary",attrs:{"to":{ path: '/login' }}},[_vm._v(_vm._s(_vm.$t('LOGIN')))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }